export const GET_ALL_E_TENDER_NOTIFICATION_REQUEST =
  "GET_NOTIFICATION_FOR_WEBSITE_REQUEST";
export const GET_ALL_E_TENDER_NOTIFICATION_SUCCESS =
  "GET_NOTIFICATION_FOR_WEBSITE_SUCCESS";
export const GET_ALL_E_TENDER_NOTIFICATION_FAILURE =
  "GET_NOTIFICATION_FOR_WEBSITE_FAILURE";
